(function ($) {

    $('[data-toggle="overlay"]').each(function () {
        var $overlay = $(this),
            cookie   = $overlay.data('overlay-cookie'),
            maxage   = $overlay.data('overlay-maxage'),
            cName    = $overlay.data('overlay-class'),
            map      = maxage ? maxage.match(/^(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)D)?(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/) : null;

        if (map !== null) {
            maxage = new Date();

            if (map[1]) maxage.setFullYear(maxage.getFullYear() + Number(map[1])); // Years
            if (map[2]) maxage.setMonth(maxage.getMonth() + Number(map[2]));       // Months
            if (map[3]) maxage.setDate(maxage.getDate() + Number(map[3]));         // Days
            if (map[4]) maxage.setHours(maxage.getHours() + Number(map[4]));       // Hours
            if (map[5]) maxage.setMinutes(maxage.getMinutes() + Number(map[5]));   // Minutes
            if (map[6]) maxage.setSeconds(maxage.getSeconds() + Number(map[6]));   // Seconds
        } else {
            maxage = Infinity;
        }

        if (cookie && window.mozCookies && mozCookies.getItem(cookie) == '1') {
            if (cName) $overlay.removeClass(cName);
            else $overlay.hide();
            $overlay[0].offsetWidth // force reflow
            return;
        } else {
            if (cName) $overlay.addClass(cName);
            else $overlay.show();
            $overlay[0].offsetWidth // force reflow
        }

        $overlay.on('hide.popel.overlay', function () {
            mozCookies.setItem(cookie, '1', maxage, '/');
        });
    });

    $(document).on('click.dismiss.popel.overlay', '[data-dismiss="overlay"]', function () {
        var $overlay = $(this).closest('[data-toggle="overlay"]');

        var event = $.Event('hide.popel.overlay');
        $overlay.trigger(event);
        if (event.isDefaultPrevented()) return;

        var cName = $overlay.data('overlay-class');

        var hideOverlay = function () {
            if (cName) $overlay.removeClass(cName);
            else $overlay.hide();
            $overlay.trigger('hidden.popel.overlay');
        };

        $.support.transition && $overlay.hasClass('fade') ?
            $overlay
                .one('bsTransitionEnd', hideOverlay)
                .emulateTransitionEnd(350) :
            hideOverlay();
    });

})(window.jQuery);
